import { render, staticRenderFns } from "./CaseInformation.vue?vue&type=template&id=b31b2644&scoped=true"
import script from "./CaseInformation.vue?vue&type=script&lang=js"
export * from "./CaseInformation.vue?vue&type=script&lang=js"
import style0 from "./CaseInformation.vue?vue&type=style&index=0&id=b31b2644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31b2644",
  null
  
)

export default component.exports